import { useContext, useState, useEffect } from "react";
import { countryRegionContextType, typeCountryDto } from "../../utils/typeDefs";
import { CountryRegionContext } from "../../core/context/countryRegionContextProvider";
import { SelectPicker, Input } from "rsuite";
import { CountryTable } from "../../Components/countryRegion/countryTable.component";

type countryRegionProps = {
  title: string;
};

const CountryRegion = ({ title }: countryRegionProps) => {
  const { regionData, countryData } = useContext(
    CountryRegionContext
  ) as countryRegionContextType;

  const [countryList, setCountryList] = useState<typeCountryDto[] | []>([]);
  const [currentRegion, setCurrentRegion] = useState<number | null>(null);
  const [searchInput, setSearchInput] = useState<string>("");

  useEffect(() => {
    if (countryData.length > 0) {
      setCountryList(countryData);
    }
  }, [countryData]);

  useEffect(() => {
    if (currentRegion && countryData.length > 0) {
      const filteredData = countryData.filter(
        (item) => item.regionId === currentRegion
      );
      setCountryList(filteredData);
    } else setCountryList(countryData);
  }, [currentRegion, countryData]);

  useEffect(() => {
    if (countryData.length > 0 && searchInput.length > 0) {
      const filteredData = countryData.filter((item) =>
        item.name.toLocaleLowerCase().startsWith(searchInput)
      );
      setCountryList(filteredData);
    } else if (countryData.length > 0 && searchInput.length === 0) {
      setCountryList(countryData);
    }
  }, [countryData, searchInput]);

  return (
    <section>
      <div className="content-box-title">
        <div className="row">
          <div className="page-header-wrapper col-12 col-md-6">
            <h1 className="page-title pb-3">{title}</h1>
          </div>
          <div className="page-filtering-wrapper col-12 col-md-6">
            <div className="picker-wrapper row gy-2">
              <div className="col-12 col-md-6">
                <Input placeholder="Search Country" onChange={setSearchInput} />
              </div>
              <div className="col-12 col-md-6">
                <SelectPicker
                  searchable={false}
                  disabled={countryData.length === 0}
                  block
                  data={regionData}
                  labelKey={"name"}
                  valueKey={"id"}
                  placeholder={"Filter by region"}
                  onChange={setCurrentRegion}
                />
              </div>
            </div>
          </div>
        </div>

        <CountryTable countryData={countryList} regionData={regionData} />
      </div>
    </section>
  );
};

export default CountryRegion;
